var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { OnInit, EventEmitter, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Select } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, combineLatest, Subject } from 'rxjs';
import { ViewService } from '../../view.service';
import { ViewAudioComponent } from '../view-audio/view-audio.component';
import { LayoutService } from '../../layout.service';
import { ViewLayout } from '../../models/view-layout.enum';
import { filter, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnvironmentApplication } from 'src/environments/models/environment-application';
import { ViewState } from '../../state/view.state';
import { StoryState } from 'src/app/story/state/story.state';
import { TextUtils } from 'src/app/shared/libraries/text-utils/text-utils';
var ViewDescriptionComponent = /** @class */ (function () {
    // ---------- Lifecycle ----------
    function ViewDescriptionComponent(viewService, layoutService, changeDetectorRef) {
        this.viewService = viewService;
        this.layoutService = layoutService;
        this.changeDetectorRef = changeDetectorRef;
        // ---------- Class Variables ----------
        this.viewLayout = ViewLayout;
        this.ngUnsubscribe = new Subject();
        this.storyTitle = '';
        this.chapterTitle = '';
        this.chapterDescription = '';
        this.chapterAudio = null;
        // ---------- Input / Output ----------
        this.layout = 'drawer';
        this._isPopulated = false;
        this.isPopulatedChange = new EventEmitter();
    }
    Object.defineProperty(ViewDescriptionComponent.prototype, "isPopulated", {
        get: function () {
            return this._isPopulated;
        },
        set: function (value) {
            this._isPopulated = value;
            this.isPopulatedChange.emit(this.isPopulated);
        },
        enumerable: true,
        configurable: true
    });
    ViewDescriptionComponent.prototype.ngOnInit = function () {
        this.initContentListener();
        this.initLayoutListener();
    };
    ViewDescriptionComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    ViewDescriptionComponent.prototype.isEnabled = function (layout) {
        return this.layoutService.isLayoutEnabled(layout);
    };
    // ---------- Listeners ----------
    ViewDescriptionComponent.prototype.initContentListener = function () {
        var _this = this;
        combineLatest(this.story$, this.chapter$, this.selectedChapterAudio$).pipe(filter(function (_a) {
            var _b = __read(_a, 3), story = _b[0], chapter = _b[1], audio = _b[2];
            return story != null && chapter != null;
        }), takeUntil(this.ngUnsubscribe)).subscribe(function (_a) {
            var _b = __read(_a, 3), story = _b[0], chapter = _b[1], audio = _b[2];
            // Only populate bookmark in web app
            _this.storyTitle = (environment.application !== EnvironmentApplication.Viewer) ? TextUtils.normalize(story.displayName) : '';
            _this.chapterTitle = TextUtils.normalize(chapter.info.displayName);
            _this.chapterDescription = chapter.info.description;
            _this.chapterAudio = audio;
            _this.isPopulated =
                !!_this.storyTitle != null ||
                    !!_this.chapterTitle ||
                    !!_this.chapterDescription ||
                    _this.chapterAudio != null;
        });
    };
    ViewDescriptionComponent.prototype.initLayoutListener = function () {
        var _this = this;
        this.layout$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (layout) {
            _this.changeDetectorRef.markForCheck();
        });
    };
    // ---------- Interaction ----------
    ViewDescriptionComponent.prototype.handlePreviousChapterClick = function () {
        this.viewService.previousChapter();
    };
    ViewDescriptionComponent.prototype.handleNextChapterClick = function () {
        this.viewService.nextChapter();
    };
    ViewDescriptionComponent.prototype.handleAudioPlayClick = function () {
        if (this.audio.playing) {
            this.audio.pause();
        }
        else {
            this.audio.play();
        }
    };
    __decorate([
        Select(StoryState.getStory),
        __metadata("design:type", Observable)
    ], ViewDescriptionComponent.prototype, "story$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapter),
        __metadata("design:type", Observable)
    ], ViewDescriptionComponent.prototype, "chapter$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapterIndex),
        __metadata("design:type", Observable)
    ], ViewDescriptionComponent.prototype, "chapterIndex$", void 0);
    __decorate([
        Select(StoryChaptersState.getChapterCount),
        __metadata("design:type", Observable)
    ], ViewDescriptionComponent.prototype, "chapterCount$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapterAudio),
        __metadata("design:type", Observable)
    ], ViewDescriptionComponent.prototype, "selectedChapterAudio$", void 0);
    __decorate([
        Select(ViewState.getLayout),
        __metadata("design:type", Observable)
    ], ViewDescriptionComponent.prototype, "layout$", void 0);
    return ViewDescriptionComponent;
}());
export { ViewDescriptionComponent };
